import { IElementLayout } from '../Element';
import ColorFilter from '../../../Component/ColorFilter';
import Renderable from '../../../Component/Renderable';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import ButtonComponent from '../../../Component/UI/ButtonComponent';
import { StartAnimation } from '../../../System/Animation/AnimationHelper';
import Interactable from '../../../Component/Interactable';
import { ITextData } from '../UIItem';
import { AnimationClipEvent } from '../../../System/Animation/AnimationClip';
import TransformComponent from '../../../Component/Transform';
import Point from '../../../Utility/Point';
import { PlaySound } from '../../../System/Audio/AudioHelper';
import Game from '../../../Game';
import { AudioTrackType } from '../../../System/Audio/AudioClip';

/**
 * @param name - Name of button
 * @param cacheKey - Image key
 * @param textLocalizationKey - Text
 * @param hidden - Visible state of Element - (Defaults to false)
 * @param align - Alignment of Text in Button - (Defaults to 'center')
 * @param enabled - Decideds if button is interactable - (Defaults to true)
 * @param textOffset - Offset of Text in Button - (Optional)
 * @param layout - Layout of Button - (Optional)
 */
export interface IButtonData {
    name: string;
    cacheKey?: string;
    hidden?: boolean;
    enabled?: boolean;
    layout?: IElementLayout;
    textData?: ITextData;
    buttonMode?: boolean;
}

export default class Button extends GameObject {
    public onCreate(params: {
        type: string;
        name: string;
        layout: IElementLayout;
        children?: Array<any>;
        components?: Array<any>;
    }): void {
        this.addComponent(ColorFilter, params);
        this.addComponent(Interactable, params);
        this.addComponent(Renderable);
        const transformComponent: TransformComponent = this.addComponent<
            TransformComponent
        >(TransformComponent, params);
        const buttonComponent: ButtonComponent = this.addComponent(
            ButtonComponent,
            params
        );
        this.on(GameObjectEvent.SELECTED, this.selected.bind(this));
        this.on(GameObjectEvent.POINTER_DOWN, this.clicked.bind(this));
        //this.on(GameObjectEvent.POINTER_UP, this.released);
        //this.on(GameObjectEvent.POINTER_OUT, this.released);
        if (transformComponent.scale) {
            buttonComponent.baseScale.copy(transformComponent.scale as Point);
        }
    }

    protected clicked(): void {
        const buttonComponent: ButtonComponent = this.getComponent(
            ButtonComponent
        );

        // Play Audio
        if (buttonComponent.onClickAudio) {
            PlaySound(buttonComponent.onClickAudio);
        }

        if (buttonComponent.onClickAnimation) {
            StartAnimation(this, buttonComponent.onClickAnimation, {
                scale: buttonComponent.baseScale,
            }).on(AnimationClipEvent.COMPLETE, this.released.bind(this));
        }
    }

    protected selected(): void {
        const buttonComponent: ButtonComponent = this.getComponent(
            ButtonComponent
        );
        if (buttonComponent.onClick) {
            buttonComponent.onClick();
        }
    }

    protected released(): void {
        const buttonComponent: ButtonComponent = this.getComponent(
            ButtonComponent
        );
        if (buttonComponent.onReleaseAnimation) {
            StartAnimation(this, buttonComponent.onReleaseAnimation, {
                scale: buttonComponent.baseScale,
            });
        }
    }

    public set enabled(value: boolean) {
        this.getComponent(ColorFilter).saturation = Number(value);
        this.getComponent(Interactable).enabled = value;
    }
    public set visible(value: boolean) {
        this.getComponent(Renderable).visible = value;
    }
}
